import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import VehiclePrivateApiModel from '../../abstracts/VehiclePrivateApiModel';

@model.staticLabel('Aménagement')
@model.urnResource('amenity')
@doc.path('/amenities/{?id}')
export default class AmenityModel extends VehiclePrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'enabled': '0' | '1';
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'title': string;
	}> = {};

	@doc.boolean declare enabled: boolean;
	@doc.string declare title: string;
}